<template>
    <div class="cc-products">
        <div class="cc-products__header">
            <div class="cc-products__title">{{ translations['Products'] }}</div>
        </div>
        <div class="cc-products__main">
            <div class="cc-content cc-content--products">
                <product v-for="product in products" v-bind:key="`${product.id_product}-${product.id_product_attribute}`" :product="product"/>
            </div>
            <div class="cc-content cc-content--prices">
                <div class="cc-content cc-content--price-products">
                    <div class="cc-price-label cc-price-label--products">{{ translations['Total price tax included'] }}</div>
                    <div class="cc-price cc-price--products">{{ summary.formattedPrices.total_price_products_with_tax }}</div>
                </div>
                <div class="cc-content cc-content--price-delivery" v-if="currentCarrier">
                    <div class="cc-price-label cc-price-label--delivery">{{ translations['Delivery fee'] }}</div>
                    <div class="cc-price cc-price--delivery">{{ currentCarrier.formattedPrices.price }}</div>
                </div>
                <div class="cc-content cc-content--price-payment" v-if="currentPayment">
                    <div class="cc-price-label cc-price-label--payment">{{ translations['Payment fee'] }}</div>
                    <div class="cc-price cc-price--payment">{{ currentPayment.formattedPrices.price }}</div>
                </div>
            </div>
            <div class="cc-content cc-content--separator">
                <div class="cc-separator"></div>
            </div>
            <div class="cc-content cc-content--voucher">
                <voucher/>
            </div>
            <div class="cc-content cc-content--prices">
                <div class="cc-content cc-content--price-total">
                    <div class="cc-price-label cc-price-label--total">{{ translations['Total'] }}</div>
                    <div class="cc-price cc-price--total">{{ summary.formattedPrices.total_price_tax_included }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Product from "./Product";
    import Voucher from "./Voucher";

    export default {
        components: {
            Product,
            Voucher,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                products: state => state.products,
                summary: state => state.summary,
                currentPayment: state => state.currentPayment,
                currentCarrier: state => state.currentCarrier,
            }),
        },
        name: 'Products',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/global/main";;

    #app {
        .cc-products {
            display: block;
            width: 100%;
        }

        .cc-products__header {
            display: block;
            width: 100%;
        }

        .cc-products__title {
            display: block;
            color: $title-color;
            font-family: $title-font-family;
            font-size: $title-font-size;
            font-weight: $title-font-weight;
            @if ($title-uppercase) {
                text-transform: uppercase;
            }
            width: 100%;
            margin-bottom: 2.5rem;
        }

        .cc-products__main {
            display: block;
            width: 100%;
            background-color: $products-background-color;
            padding: 1rem;
        }

        .cc-content {
            display: block;
            width: 100%;

            &.cc-content--prices {
                display: block;
            }

            &.cc-content--price-products {
                padding: 1rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }

            &.cc-content--price-delivery {
                padding: 1rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }

            &.cc-content--price-payment {
                padding: 1rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }

            &.cc-content--separator {
                margin-top: 2rem;
                margin-bottom: 2rem
            }

            &.cc-content--voucher {
                padding: 1rem;
            }

            &.cc-content--price-total {
                padding: 2rem 1rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
        }

        .cc-separator {
            width: 100%;
            height: 3px;
            background-color: $separator-color;
        }
    }
</style>
